import { AlertColor } from "@mui/material";
import { createSlice } from "@reduxjs/toolkit";

const genKeys = () => (Math.random() + 1).toString(36).substring(7);

export interface NotificationType {
    key: string;
    message: string | null;
    severity?: AlertColor;
    autoHideDuration?: number | null;
}

export interface NotificationState {
    notifcation: NotificationType
}

const initialState: NotificationState = {
    notifcation: {
        key: genKeys(),
        message: null
    }
};

export const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    notify: (state, action) => {
      const { message, severity, autoHideDuration } = action.payload;
      state.notifcation.key = genKeys();
      state.notifcation.message = message;
      state.notifcation.severity = severity || "info"
      state.notifcation.autoHideDuration = autoHideDuration || null
    }
  }
});

export const { notify } = notificationSlice.actions;
export default notificationSlice.reducer;
